export default {
  getUser: state => state.user,
  getEmail: state => state.email,
  getNeighborhood: state => state.neighborhood,
  getRent: state => state.rent,
  getRentsPreRegistration: state => state.rentsPreRegistration
}



// WEBPACK FOOTER //
// ./src/store/getters.js